export { default } from './LegalSurvey';
